const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Blik24 = function Blik24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M34.0961 3H1.90421C1.65429 2.99985 1.40678 3.05244 1.17583 3.15478C0.944878 3.25711 0.734998 3.40718 0.558176 3.59642C0.381353 3.78566 0.241051 4.01036 0.145279 4.2577C0.0495069 4.50504 0.0001411 4.77016 0 5.03794V18.9623C0.00014109 19.2301 0.0495089 19.4952 0.145284 19.7425C0.241059 19.9899 0.381366 20.2145 0.558192 20.4038C0.735018 20.593 0.944899 20.743 1.17585 20.8453C1.4068 20.9476 1.6543 21.0002 1.90421 21H34.0961C34.3459 21.0002 34.5934 20.9476 34.8243 20.8452C35.0553 20.7429 35.2651 20.5929 35.4419 20.4037C35.6187 20.2144 35.759 19.9898 35.8547 19.7425C35.9505 19.4952 35.9999 19.2301 36 18.9623V5.03794C35.9997 4.49719 35.799 3.9787 35.4419 3.59652C35.0849 3.21434 34.6007 2.99977 34.0961 3Z",
      fill: "url(#paint0_linear_19953_318)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M13.7906 6.94238C13.7906 7.4696 13.5884 7.97524 13.2285 8.34804C12.8687 8.72085 12.3806 8.93029 11.8717 8.93029C11.3628 8.93029 10.8747 8.72085 10.5149 8.34804C10.155 7.97524 9.95288 7.4696 9.95288 6.94238C9.95288 6.41515 10.155 5.90952 10.5149 5.53671C10.8747 5.16391 11.3628 4.95447 11.8717 4.95447C12.3806 4.95447 12.8687 5.16391 13.2285 5.53671C13.5884 5.90952 13.7906 6.41515 13.7906 6.94238Z",
      fill: "url(#paint1_linear_19953_318)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M28.5476 18.202H31.3105L27.991 13.7603L31.0011 9.9438H28.4951L25.5391 13.7842V5.59469H23.3937V18.202H25.5391L25.5375 13.7948L28.5476 18.202ZM19.347 9.9424H21.4919V18.2006H19.347V9.9424ZM15.2987 5.59216H17.4436V18.2006H15.2987V5.59216ZM9.72224 9.85994C9.05072 9.85896 8.38948 10.0309 7.79799 10.3603V5.59244H5.65283V14.0742C5.65262 14.9079 5.89106 15.723 6.338 16.4163C6.78494 17.1097 7.4203 17.6501 8.16374 17.9694C8.90718 18.2886 9.7253 18.3723 10.5146 18.2098C11.304 18.0473 12.0291 17.646 12.5983 17.0566C13.1674 16.4671 13.5551 15.7161 13.7122 14.8984C13.8694 14.0807 13.789 13.2331 13.4811 12.4628C13.1733 11.6925 12.6518 11.034 11.9828 10.5707C11.3137 10.1074 10.527 9.86005 9.72224 9.85994ZM9.72224 16.103C9.33498 16.103 8.95641 15.984 8.63441 15.7611C8.31241 15.5383 8.06144 15.2215 7.91323 14.8508C7.76502 14.4801 7.72622 14.0723 7.80176 13.6788C7.87729 13.2853 8.06375 12.9238 8.33757 12.6401C8.61138 12.3564 8.96026 12.1632 9.34007 12.0849C9.71989 12.0066 10.1136 12.0467 10.4714 12.2002C10.8292 12.3537 11.135 12.6137 11.3502 12.9472C11.5654 13.2808 11.6803 13.6729 11.6803 14.0742C11.6804 14.3406 11.6299 14.6044 11.5315 14.8506C11.4331 15.0968 11.2889 15.3205 11.1071 15.5089C10.9252 15.6973 10.7093 15.8468 10.4717 15.9487C10.2341 16.0507 9.97943 16.1031 9.72224 16.103Z",
      fill: "white",
    }),
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_19953_318",
          x1: "18.0001",
          y1: "20.9133",
          x2: "18.0001",
          y2: "3.08665",
          gradientUnits: "userSpaceOnUse",
        },
        /*#__PURE__*/ React.createElement("stop", {
          stopColor: "#5A5A5A",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.146",
          stopColor: "#484848",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.52",
          stopColor: "#212121",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.817",
          stopColor: "#080808",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "1",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "linearGradient",
        {
          id: "paint1_linear_19953_318",
          x1: "10.5143",
          y1: "8.34861",
          x2: "13.3251",
          y2: "5.63556",
          gradientUnits: "userSpaceOnUse",
        },
        /*#__PURE__*/ React.createElement("stop", {
          stopColor: "#E52F08",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "1",
          stopColor: "#E94F96",
        })
      )
    )
  );
};
Blik24.defaultProps = {
  width: "36",
  height: "24",
  viewBox: "0 0 36 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Blik24,
};
export function Blik(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Blik' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
